module.exports = __webpack_public_path__ + "img/skills_frontend.913369cd.png";